import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface PipelineRow {
  readonly pipelineId: string;
  readonly pipelineReference: string;
  readonly pipelineType: string;
  readonly status: string;
  readonly releaseVersion: string | null;
}

export function M19PipelineDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<PipelineRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: PipelineRow[] }>('/v1/platform/pipelines', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m19.pipeline.loading')}</p>;
  return (
    <main aria-label="pipeline-dashboard">
      <h1>{t('m19.pipeline.title')}</h1>
      <table aria-label="pipelines-table">
        <thead><tr><th>{t('m19.pipeline.colReference')}</th><th>{t('m19.pipeline.colType')}</th><th>{t('m19.pipeline.colStatus')}</th><th>{t('m19.pipeline.colVersion')}</th></tr></thead>
        <tbody>
          {rows.map((p) => (
            <tr key={p.pipelineId}>
              <td>{p.pipelineReference}</td>
              <td>{p.pipelineType}</td>
              <td>{p.status}</td>
              <td>{p.releaseVersion ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
